import { graphql } from 'react-relay';

export const gqlRemoveFromStudioListingMediaGroup = graphql`
  mutation removeFromStudioListingMediaGroupMutation($membershipIds: [String!]!, $listingMediaGroupId: String!) {
    studioRemoveFromListingMediaGroup(membershipIds: $membershipIds, listingMediaGroupId: $listingMediaGroupId) {
      success
    }
  }
`;
